import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/_user/accounts/$accountId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/accounts/$accountId/overview',
      params: { accountId: params.accountId },
      search: {},
    })
  },
})
